/* eslint-disable class-methods-use-this */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import ContentHub from '@nmx/template/dist/componentLibrary/modules/ContentHub';
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
import Theme from '@nmx/template/dist/componentLibrary/Theme';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import AdvisorConnectModule from './components/advisorConnectModule';
import CredentialCalloutGrouping from './components/credentialCalloutGrouping';
import Faq from './components/faq';
import HeroSection from './components/heroSection';
import IntroSection from './components/introSection';
import Metadata from './components/metadata/metadata';
import ProductCalloutGrouping1 from './components/productCalloutGrouping1';
import ProductCalloutGrouping2 from './components/productCalloutGrouping2';
import QuizCallout from './components/quizCallout';
import UnderstandingProduct from './components/understandingProduct';
// images for prefetch
import highResDesktopImage from './components/heroSection/images/non-qualified-retirement-plan-desktop.webp';
import highResMobileImage from './components/heroSection/images/non-qualified-retirement-plan-mobile.webp';
// dislaimer footnotes
import {
  LoyaltyBasedOnClientDataInsuranceProducts,
  RankingNmInvestmentsServices,
} from '../../../utils/disclaimerFootnotes/disclaimerFootnotes';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps, contentHubItems } = useRouteData();

  const thisContentHubHeadingText = <>Boost your knowledge on <WidowBlock>retirement savings.</WidowBlock></>;

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Financial Planning',
          linkUrl: '/financial-planning/',
          linkAriaLabel: 'Northwestern Mutual Financial Planning',
        },
        {
          pageName: 'Retirement Planning',
          linkUrl: '/retirement-planning/',
          linkAriaLabel: 'Northwestern Mutual Retirement Planning',
        },
        {
          pageName: 'Non-Qualified Retirement Plan',
          linkUrl: '/financial-planning/retirement-planning/non-qualified-retirement-plan/',
          linkAriaLabel: 'Northwestern Mutual Non-Qualified Retirement Plan',
        },
      ]}
      disclaimerFootnotes={[
        <>
          {RankingNmInvestmentsServices(1)}
        </>,
        <>
          {LoyaltyBasedOnClientDataInsuranceProducts(2)}
        </>,
      ]}
      disableDisclaimerTopBorder>

      <Head>
        {/* prefetch expensive images */}
        <link rel='preload' href={highResMobileImage} as='image' media={`(max-width: ${Theme.breakpoints.values.medium}px)`} />
        <link rel='preload' href={highResDesktopImage} as='image' media={`(min-width: ${Theme.breakpoints.values.medium + 1}px)`} />
      </Head>

      <Metadata
        image={highResDesktopImage}
        pageDescription={pageProps.pageDescription}
        pageTitle={pageProps.pageTitle}
      />

      <HeroSection />

      <IntroSection />

      <ProductCalloutGrouping1 />

      <ProductCalloutGrouping2 />

      <UnderstandingProduct />

      <QuizCallout />

      <Faq />

      <CredentialCalloutGrouping />

      <ContentHub
        sectionId='content-hub'
        backgroundVariant='lightC'
        themeType='lightTheme'
        headingText={thisContentHubHeadingText}
        contentHubItems={contentHubItems} // defined in route.js
        config={config}
      />

      <AdvisorConnectModule />

    </Page>
  );
};
